import axios from 'axios';
import marker_ico from '@/assets/images/marker_wifi.png';
import { FALLBACK_LOCATIONS } from '@/data/fallbackLocations';

const API_URL = 'https://www.datos.gov.co/resource/r7mn-ty3w.json';
const CACHE_KEY = 'wifi_locations_cache';

function driveShareLinkToImageUrl(link) {
  const match = link && link.match(/\/file\/d\/([^/]+)/);
  if (!match) return null;
  return `/img/zonas/${match[1]}.jpg`;
}

function transformLocation(item) {
  const image = driveShareLinkToImageUrl(item.imagen_ubicacion);
  return {
    lat: parseFloat(item.latitud),
    lng: parseFloat(item.longitud),
    title: item.zona_wifi,
    icon: marker_ico,
    dir: `${item.barrio}, ${item.direccion}`,
    images: image ? [image] : [],
    estado: item.estado || null,
    conexion: item.conexion || null,
    ssid: item.ssid || null,
    radio_cobertura: item.radio_cobertura || null,
  };
}

async function loadFromApi() {
  const headers = {};
  if (process.env.VUE_APP_SOCRATA_APP_TOKEN) {
    headers['X-App-Token'] = process.env.VUE_APP_SOCRATA_APP_TOKEN;
  }
  const response = await axios.get(API_URL, {
    headers,
    params: { $limit: 5000 },
  });
  const raw = response.data;
  const items = Array.isArray(raw) ? raw : (raw.data || raw.rows || []);
  if (!items.length) throw new Error('API returned empty dataset');
  return items
    .filter(item => item.latitud && item.longitud)
    .map(transformLocation);
}

function loadFromCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
  } catch {
    return null;
  }
}

function saveToCache(locations) {
  try {
    // eslint-disable-next-line no-unused-vars
    const toStore = locations.map(({ icon, ...rest }) => rest);
    localStorage.setItem(CACHE_KEY, JSON.stringify(toStore));
  } catch (e) {
    console.warn('No se pudo guardar en localStorage:', e.message);
  }
}

function withIcon(locations) {
  return locations.map(loc => ({ ...loc, icon: marker_ico }));
}

export async function loadLocations() {
  try {
    const locations = await loadFromApi();
    saveToCache(locations);
    return locations;
  } catch (err) {
    console.warn('API no disponible, intentando caché:', err.message);
    const cached = loadFromCache();
    if (cached) {
      return withIcon(cached);
    }
    console.warn('Caché vacío, usando fallback hardcodeado');
    return withIcon(FALLBACK_LOCATIONS);
  }
}
